// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";

type $Props = {
  classes: Object,
  children: any,
};

const AboutContainer = ({ classes, children }: $Props) => (
  <div className={classes.root}>{children}</div>
);

const styles = () => ({
  root: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "center",
    alignItems: "flex-start",
    position: "relative",
    width: "100%",
    maxWidth: "1170px",
    margin: "0 auto",
    padding: "20px 35px 40px",
  },
});

export default withStyles(styles)(AboutContainer);
